/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ROUTES } from "@nf/constants";
import cx from "classnames";

import { useRouter } from "hooks";
import type { IPaymentV2ScreenRouteProps } from "../../PaymentScreen";

import styles from "./StepsProgressBar.module.scss";

export interface StepsProgressBarProps {
  stepsAmount?: number;
  activeStep: number;
}

export const StepsProgressBar = ({
  stepsAmount = 4,
  activeStep = 3,
}: StepsProgressBarProps) => {
  const router = useRouter();
  const { offerId, offerHandle } = router.query as IPaymentV2ScreenRouteProps;

  const handleStepClick = (index: number) => {
    const step = index + 1;

    if (step === 3 && activeStep === 4) {
      router.replace({
        pathname: ROUTES.PAYMENT_SUBSCRIPTION,
        query: { offerId, offerHandle },
      });
    }
  };

  const progressPercent = ((activeStep - 1) / (stepsAmount - 1)) * 100;

  return (
    <div className={styles.steps}>
      <div className={styles.bar}>
        <div
          className={styles.barFill}
          style={{ width: `${Math.min(progressPercent, 100)}%` }}
        />
      </div>

      {[...Array(stepsAmount)].map((_, index) => {
        const step = index + 1;
        const isActive = step <= activeStep;
        const isClickable =
          step !== activeStep && step > 2 && step < activeStep;

        return (
          <div
            key={step}
            className={cx(styles.step, {
              [styles.active]: isActive,
              [styles.activeCursor]: isClickable,
            })}
            onClick={() => handleStepClick(index)}
          >
            {step}
          </div>
        );
      })}
    </div>
  );
};
